import { useDeleteChurchMutation } from '../hooks/useDeleteChurchMutation'
import { useChurchesStore } from '../store/churchesStore'
import type { ApiError } from '@/types/api'
import { Modal } from '@/components/custom/modal'
import LoadingButton from '@/components/custom/loading-button'
import { notifyRequestError } from '@/utils/notifyRequestError'

export function DeleteChurch({
  id,
  trigger,
  open,
  onClose,
}: {
  id: string | null
  trigger?: React.ReactNode
  open?: boolean
  onClose?: () => void
}) {
  const { mutateAsync: deleteChurchMutation, isPending } =
    useDeleteChurchMutation()

  const churches = useChurchesStore((s) => s.churches)
  const church = churches.find((u) => u._id === id)

  const handleDeleteChurch = async () => {
    if (!church) return

    try {
      await deleteChurchMutation(church._id)
      onClose?.()
    } catch (error) {
      notifyRequestError(error as ApiError, 'Failed to delete church')
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      trigger={trigger}
      title="Delete Church"
    >
      <div className="space-y-4">
        <p>
          Are you sure you want to delete church <strong>{church?.name}</strong>
          ?
          <br />
          <span className="text-red-500 font-semibold">
            This action is permanent and cannot be undone.
          </span>
        </p>
        <LoadingButton
          type="submit"
          className="w-full"
          isLoading={isPending}
          disabled={isPending}
          onClick={handleDeleteChurch}
        >
          {isPending ? 'Deleting...' : 'Delete'}
        </LoadingButton>
      </div>
    </Modal>
  )
}
